export default "__VITE_ASSET__d5bf4803__"